import { render, staticRenderFns } from "./requerimientos-sistema.vue?vue&type=template&id=9f9d6666&"
import script from "./requerimientos-sistema.vue?vue&type=script&lang=js&"
export * from "./requerimientos-sistema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports